<template>
  <div>
    <h1>Dashboard</h1>
    <div v-if="is_loaded">
      <div v-if="hasRole('admin') || hasRole('editor') || hasRole('sales') || hasRole('tester') || hasRole('callcenter')">

      </div>
      <div v-else-if="is_premium">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="card">
                <div class="card-body px-3 pt-4">
                  <h4 class="card-title">Investor World Map</h4>
                  <iframe id="map_url_frame" style="border:0; width:100%; height:440px;background:transparent;" :src="map_url"></iframe>
                </div>
              </div>
            </div>
           <!--  <div class="col-12 col-sm-6">
              <div class="card">
                <div class="card-body px-3 pt-4">
                  <h4 class="card-title">Pie Chart</h4>
                  <iframe id="piechart_url_frame" style="border:0; width:100%; height:440px;background:transparent;" :src="piechart_url"></iframe>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="card">
                <div class="card-body px-3 pt-4">
                  <h4 class="card-title">Bar Chart</h4>
                  <iframe id="barchart_url_frame" style="border:0; width:100%; height:440px;background:transparent;" :src="barchart_url"></iframe>
                </div>
              </div>
          </div> -->
            <div class="col-12 col-sm-6">
                 <div class="card">
                   <div class="card-body px-3 pt-4">
                     <h4 class="card-title">Investor Treemap</h4>
                     <iframe id="treemap_url_frame" style="border:0; width:100%; height:440px;background:transparent;" :src="treemap_url"></iframe>
                   </div>
                 </div>
               </div>

          </div>
          <div class="row pta-pipeline-status-home">
            <div class="col-12 col-sm-3">
              <div class="card">
                <div class="card-body px-3 pt-4">
                  <span>{{ investors_number }}</span>Active Deals<br />&nbsp;

                </div>
              </div>
              </div>
            <div class="col-12 col-sm-6">
              <div class="card">
                <div class="card-body px-3 pt-4">
                <span>${{ investors_amount | formatAmount }}</span>Average Deal Value<br />&nbsp;
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="card">
                <div class="card-body px-3 pt-4">

                <span>{{ investors_completed }}</span>Number of <br />meetings completed

              </div> </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12">
                <a href="/account/calendar" class="pta-button">PROCEED TO BOOK A CALL WITH US</a>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>Keep an eye on the metrics that matter for your performance.</p>
        <img src="/images/dashboard_preview.png" style="width:100%;max-width:1280px;display:block;" />
        <a href="/account/calendar" class="pta-button">PROCEED TO BOOK A CALL WITH US</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  mounted(){
    $("body").removeClass("page-login");

    if(this.hasRole('admin')) {
      this.$router.push('/account/users/general-partners');
    }
    this.getUserPipelineStages();
  },
  methods: {
    hasRole(role){
      return helper.hasRole(role);
    },
    getQuestionnaire(){
      axios.get('/api/user/profile/questionnaire')
          .then(response => response.data)
          .then(response => {
            this.is_premium     = response.user.profile.is_premium;
            this.is_loaded = true;

            if(this.is_premium ){
              this.getUserInvestors();
              this.barchart_url = "https://proptecham.ai/plot/bar";
              this.piechart_url = "https://proptecham.ai/plot/pie";
              this.treemap_url = "https://proptecham.ai/plot/tree";
              this.map_url = "https://proptecham.ai/plot/map";
            }
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getUserPipelineStages(){
      axios.get('/api/user-pipeline-stages')
          .then(response => response.data)
          .then(response => {
            this.pipeline_stages = response;

            this.pipeline_stages.forEach(function (item) {
              if(item.position==13){
                this.last_stage_id = item.pd_stage_id;
              }
            }.bind(this));

            this.getQuestionnaire();
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getUserInvestors(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterInvestorForm);
      axios.get('/api/user-investor?page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.investors = response;
            this.investors_number = this.investors.data.length;
            let investors_amount_sum = 0;
            this.investors_completed = 0;
            this.investors.data.forEach(function (item) {
              // investors_amount_sum += item.amount;
              this.investors_amount += item.amount;
              if(this.last_stage_id==item.pd_stage_id){
                this.investors_completed++;
              }
            }.bind(this));

            if(this.investors_amount && this.investors_number){
              this.investors_amount = (this.investors_amount / this.investors_number);
            }else{
              this.investors_amount = 0;
            }

            /* if(investors_amount_sum && this.investors_number){
              this.investors_amount = (investors_amount_sum / this.investors_number);
            }else{
              this.investors_amount = 0;
            }*/
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
  },
  data() {
    return {
      filterInvestorForm: {
        sort_by : 'created_at',
        order: 'asc',
        page_length: 10000
      },
      is_premium: false,
      is_loaded: false,
      map_url: '',
      treemap_url: '',
      barchart_url: '',
      piechart_url: '',
      last_stage_id: 0,
      pipeline_stages: '',
      investors_number: 0,
      investors_amount: 0,
      investors_completed: 0
    }
  },
  computed: {
  },
  filters: {
    formatAmount(amount){
      return helper.formatAmount(amount);
    }
  },
}
</script>
<style>
.pta-pipeline-status-home{
  font-size:20px;
  text-align: center;
}
.pta-pipeline-status-home span{
  display:block;
  font-size:30px;
  font-weight:600;
  margin-bottom:0px;
}
.pta-pipeline-status-home span i{
  font-style: normal;
  font-size:18px;
}
</style>